var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":3000,"show-indicators":false}},_vm._l((_vm.swipeData),function(item,index){return _c('van-swipe-item',{key:index},[_c('img',{attrs:{"src":item.img,"alt":""},on:{"click":function($event){return _vm.toUrl(item.link)}}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-174be5f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productList/module/swipePoster.vue
// module id = null
// module chunks = 